import NotificationType from '../NotificationType';
import { batchDocumentRoute } from './batchDocumentRoute';

export default class ReimbursementBackupGenerated extends NotificationType {
  get icon() {
    return 'fa-solid fa-file-zipper';
  }

  resolveRoute(notification) {
    return batchDocumentRoute(notification);
  }
}
